import { Box, Button, Divider, Fade, Modal, Stack } from '@mui/material';
import i18n from '../../../libs/language';
import DeleteIcon from '@old/assets/svg/core/trash-red.svg';
import { PropsWithChildren, ReactElement } from 'react';

type DeleteModalStandAloneProps = {
  open: boolean;
  targetName: string | ReactElement;
  setIsOpen: (value: boolean) => void;
  handleOkEvent: () => void;
};

export function DeleteModalStandAlone({
  open,
  setIsOpen,
  targetName,
  handleOkEvent,
}: DeleteModalStandAloneProps) {
  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <MyModal open={open} onClose={handleClose}>
      <Stack direction="row" spacing={2} alignItems="center" style={{ fontWeight: '600', fontSize: '24px' }}>
        <img style={{ width: 20, height: 20 }} src={DeleteIcon} />
        <Box>{i18n.t('app.delete_modal.title')}</Box>
      </Stack>
      <Divider />
      <Box>
        {`${i18n.t('app.delete_modal.question')}`}
        <Box style={{ fontWeight: 600, color: '#F00', display: 'inline-block' }}>&nbsp;{targetName}</Box>?
      </Box>
      <Stack direction="row" spacing={1} justifyContent="flex-end" marginBlockStart={1}>
        <Button
          variant="outlined"
          style={{
            width: 115,
            borderRadius: 100,
            textTransform: 'none',
            border: 'none',
            color: 'black',
          }}
          onClick={handleClose}
        >
          {i18n.t('app.delete_modal.cancel_button_text')}
        </Button>
        <Button
          variant="contained"
          type="submit"
          color="error"
          disabled={false}
          style={{
            color: '#FFF',
            width: 115,
            borderRadius: 100,
            fontWeight: 600,
            textTransform: 'none',
          }}
          onClick={() => handleOkEvent()}
        >
          {i18n.t('app.delete_modal.confirm_delete_button_text')}
        </Button>
      </Stack>
    </MyModal>
  );
}

type ModalProps = {
  open: boolean;
  onClose: () => void;
};

function MyModal({ open, onClose, children }: PropsWithChildren<ModalProps>) {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 800,
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  };

  const handleClose = (_: never, reason: string) => {
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Modal open={open} keepMounted onClose={handleClose}>
      <Fade in={open} appear={false} timeout={175}>
        <Box sx={style}>{children}</Box>
      </Fade>
    </Modal>
  );
}
